import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";
import MoneyFlowDiagram from "./partnerships/MoneyFlowDiagram";

const Partnerships = () => {
  const { language } = useLanguage();
  const content = {
    fr: {
      title: "Un processus transparent et sécurisé",
      mainText: "Pour garantir la sécurité de vos contributions, nous collaborons avec des banques européennes agréées. Vos dons sont conservés en toute sérénité jusqu'au 18ᵉ anniversaire de votre enfant, puis lui sont directement versés.",
      flowTitle: "Le parcours de votre contribution",
      guarantee: "✨ Vos fonds sont toujours protégés dans la banque partenaire et seront disponibles pour votre enfant quoi qu'il arrive."
    },
    en: {
      title: "A transparent and secure process",
      mainText: "We partner with regulated European banks to keep your contributions safe. It's simple: your gifts are held securely until your child turns 18, then transferred directly to them.",
      flowTitle: "Your contribution's journey",
      guarantee: "✨ Your funds are always protected in our partner bank and will be available for your child no matter what."
    },
    de: {
      title: "Ein transparenter und sicherer Prozess",
      mainText: "Wir arbeiten mit regulierten europäischen Banken zusammen, um Ihre Beiträge zu schützen. Es ist einfach: Ihre Geschenke werden sicher aufbewahrt, bis Ihr Kind 18 wird, dann direkt übertragen.",
      flowTitle: "Der Weg Ihres Beitrags",
      guarantee: "✨ Ihre Gelder sind immer in unserer Partnerbank geschützt und stehen Ihrem Kind zur Verfügung, egal was passiert."
    }
  };
  
  return (
    <section id="partnerships" className="section-padding bg-gradient-to-b from-legatia-light/30 to-white">
      <div className="container mx-auto relative z-10 px-4">
        <div className="text-center mb-8 md:mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4 px-2 text-legatia-orange">
            {content[language].title}
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-0 shadow-xl overflow-hidden bg-white/95 backdrop-blur-sm rounded-xl md:rounded-2xl mb-6 md:mb-8 mx-2 md:mx-0">
            <CardContent className="p-4 md:p-8">
              <p className="text-lg md:text-xl text-gray-700 mb-6 md:mb-8 text-center font-medium leading-relaxed">
                {content[language].mainText}
              </p>

              {/* Money Flow Diagram */}
              <div className="border-t border-legatia-orange/10 pt-6 md:pt-8">
                <h4 className="text-base md:text-lg font-semibold text-center mb-4 md:mb-6 text-gray-800 px-2">
                  {content[language].flowTitle}
                </h4>
                <MoneyFlowDiagram />
              </div>

              {/* Guarantee */}
              <div className="mt-6 md:mt-8 bg-gradient-to-r from-legatia-light/40 to-legatia-yellow/20 border border-legatia-orange/30 rounded-lg p-4 md:p-6">
                <p className="text-center text-sm md:text-lg text-gray-700 font-medium leading-relaxed">
                  {content[language].guarantee}
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Partnerships;
